<template>
    <v-container>
        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="6" v-if="clients">
                <v-combobox
                    v-model="accountingClient"
                    :items="clients"
                    outlined
                    dense
                    hide-details
                    @change="resetDisplay"
                    class="pr-2"
                    :item-title="(item) => item.name"
                />
            </v-col>
            <v-col cols="6" v-if="!updateLoading">
                <v-select
                    v-model="invoiceId"
                    :items="invoices"
                    item-value="id"
                    outlined
                    hide-details
                    @update:model-value="resetDisplay"
                    density="compact"
                    :item-title="(item) => item.title"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="12" v-if="updateLoading">
                <v-progress-circular indeterminate color="primary" class="mr-3" />
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="12" v-if="!updateLoading">
                <v-card class="default_card" elevation="0" v-if="invoiceId">
                    <v-row no-gutters class="py-2">
                        <v-col cols="9" class="px-2 headline">
                            {{ title }}
                        </v-col>
                        <v-col cols="3" class="d-flex px-2 justify-end align-center">
                            <v-btn-icon
                                icon="$oss-download"
                                class="mr-2"
                                v-if="invoiceId && !invoiceId.startsWith('date#')"
                                @click.stop="download"
                                size="small"
                            />
                            <v-btn-toggle v-model="displayType">
                                <v-btn :value="'chart'" icon="$fa-chart-pie" />
                                <v-btn :value="'table'" icon="$fa-list-ul" />
                                <v-btn :value="'priceList'" icon="$fa-list-ul" />
                            </v-btn-toggle>
                        </v-col>
                        <v-col cols="12">
                            <v-window v-model="displayType" touchless>
                                <v-window-item :value="'priceList'">
                                    <v-row
                                        class="d-flex justify-center"
                                        v-if="clientPriceList && clientPriceList.prices"
                                    >
                                        <v-col cols="12">
                                            <v-data-table
                                                :headers="priceListHeaders"
                                                :items="clientPriceList.prices"
                                                :fixed-header="true"
                                                :virtual-scroll="true"
                                                class="table elevation-0"
                                            >
                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td>
                                                            {{
                                                                props.item.invoiceProduct.title ||
                                                                "XXX"
                                                            }}
                                                        </td>
                                                        <td class="text-right">
                                                            {{
                                                                props.item.invoiceProduct.unitPrice
                                                            }}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item :value="'chart'">
                                    <div
                                        :style="
                                            $vuetify.display.mobile
                                                ? 'width: 100%; height: 100%;'
                                                : 'width: 100%; height: 350px;'
                                        "
                                    >
                                        <DoughnutChart
                                            v-if="statsBilling"
                                            :data="statsBilling"
                                            :options="{
                                                plugins: {
                                                    legend: {
                                                        display: $vuetify.display.mobile
                                                            ? false
                                                            : true,
                                                        position: 'bottom',
                                                    },
                                                },
                                                maintainAspectRatio: false,
                                                responsive: true,
                                            }"
                                        />
                                    </div>
                                    <div
                                        class="d-flex headline justify-center align-center"
                                        :style="
                                            $vuetify.display.mobile
                                                ? 'margin-top: -226px; height: 200px;'
                                                : 'margin-top: -376px; height: 350px;'
                                        "
                                    >
                                        <span>{{
                                            newCommonFormatCurrency(totalAmountHT, undefined)
                                        }}</span>
                                    </div>
                                </v-window-item>

                                <v-window-item :value="'table'">
                                    <v-expansion-panels accordion flat v-model="panel">
                                        <v-expansion-panel readonly style="background: transparent">
                                            <v-expansion-panel-title
                                                class="primary--text"
                                                expand-icon
                                            >
                                                <v-row no-gutters class="pr-5">
                                                    <v-col cols="4"> </v-col>
                                                    <v-col cols="2">
                                                        <strong>Quantité</strong>
                                                    </v-col>
                                                    <v-col cols="2" class="d-flex justify-end">
                                                        <strong>Prix unitaire</strong>
                                                    </v-col>
                                                    <v-col cols="2" class="d-flex justify-end">
                                                        <strong>Prix HT</strong>
                                                    </v-col>
                                                    <v-col cols="2" class="d-flex justify-end pr-2">
                                                        <strong>Prix TTC</strong>
                                                    </v-col>
                                                </v-row>
                                            </v-expansion-panel-title>
                                        </v-expansion-panel>
                                        <v-expansion-panel
                                            v-for="(line, i) in lines"
                                            :key="i"
                                            :disabled="line.product.title.startsWith('Forfait')"
                                            style="background: transparent"
                                        >
                                            <v-expansion-panel-title class="primary--text">
                                                <v-row
                                                    no-gutters
                                                    :class="
                                                        line.product.title.startsWith('Forfait')
                                                            ? 'pr-5'
                                                            : ''
                                                    "
                                                >
                                                    <v-col cols="4">
                                                        {{ getProductTitle(line.product) }}
                                                    </v-col>
                                                    <template v-if="panel !== i + 1">
                                                        <v-col cols="2">
                                                            {{ line.quantity }}
                                                        </v-col>
                                                        <v-col cols="2" class="d-flex justify-end">
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    line.unitPrice,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </v-col>
                                                        <v-col cols="2" class="d-flex justify-end">
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    line.unitPrice * line.quantity,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </v-col>
                                                        <v-col
                                                            cols="2"
                                                            class="d-flex justify-end pr-2"
                                                        >
                                                            <strong>{{
                                                                newCommonFormatCurrency(
                                                                    (line.unitPrice +
                                                                        line.unitPrice *
                                                                            (line.product.vatRate /
                                                                                100)) *
                                                                        line.quantity,
                                                                    undefined,
                                                                )
                                                            }}</strong>
                                                        </v-col>
                                                    </template>
                                                </v-row>
                                            </v-expansion-panel-title>
                                            <v-expansion-panel-text>
                                                <v-card
                                                    class="inside_card rounded-xl"
                                                    elevation="0"
                                                    style="overflow: hidden"
                                                >
                                                    <v-row no-gutters class="d-flex justify-center">
                                                        <v-col cols="12">
                                                            <oss-data-table
                                                                :headers="headers"
                                                                :items="getClients(line.product.id)"
                                                                :fixed-header="true"
                                                                :virtual-scroll="true"
                                                                class="table elevation-0"
                                                            >
                                                                <template v-slot:item="props">
                                                                    <tr>
                                                                        <td>
                                                                            {{
                                                                                props.item[0]
                                                                                    .accountingFirmClient
                                                                                    .client.name
                                                                            }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ props.item.length }}
                                                                        </td>
                                                                        <td class="text-right">
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    line.unitPrice,
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </td>
                                                                        <td class="text-right">
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    line.unitPrice *
                                                                                        props.item
                                                                                            .length,
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </td>
                                                                        <td class="text-right">
                                                                            <strong>{{
                                                                                newCommonFormatCurrency(
                                                                                    (line.unitPrice +
                                                                                        line.unitPrice *
                                                                                            (line
                                                                                                .product
                                                                                                .vatRate /
                                                                                                100)) *
                                                                                        props.item
                                                                                            .length,
                                                                                    undefined,
                                                                                )
                                                                            }}</strong>
                                                                        </td>
                                                                        <!-- <td class="text-center">
                                                                            <v-btn-icon
                                                                                icon="$oss-eye"
                                                                                @click.stop="
                                                                                    showClientDetail(
                                                                                        props.item
                                                                                    )
                                                                                "
                                                                                size="small"
                                                                            />
                                                                        </td> -->
                                                                    </tr>
                                                                </template>

                                                                <template #body.append>
                                                                    <tr style="font-weight: bold">
                                                                        <td>
                                                                            <strong>Total</strong>
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ line.quantity }}
                                                                        </td>
                                                                        <td class="text-right">
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    line.unitPrice,
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </td>
                                                                        <td class="text-right">
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    line.unitPrice *
                                                                                        line.quantity,
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </td>
                                                                        <td class="text-right">
                                                                            <strong>{{
                                                                                newCommonFormatCurrency(
                                                                                    (line.unitPrice +
                                                                                        line.unitPrice *
                                                                                            (line
                                                                                                .product
                                                                                                .vatRate /
                                                                                                100)) *
                                                                                        line.quantity,
                                                                                    undefined,
                                                                                )
                                                                            }}</strong>
                                                                        </td>
                                                                        <td class="text-center" />
                                                                    </tr>
                                                                </template>
                                                            </oss-data-table>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-expansion-panel-text>
                                        </v-expansion-panel>
                                        <v-expansion-panel readonly style="background: transparent">
                                            <v-expansion-panel-title
                                                class="primary--text"
                                                expand-icon
                                            >
                                                <v-row no-gutters class="pr-5">
                                                    <v-col cols="4">
                                                        <strong>Total</strong>
                                                    </v-col>
                                                    <v-col cols="2"> </v-col>
                                                    <v-col cols="2"> </v-col>
                                                    <v-col cols="2" class="d-flex justify-end">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                totalAmountHT,
                                                                undefined,
                                                            )
                                                        }}
                                                    </v-col>
                                                    <v-col cols="2" class="d-flex justify-end pr-2">
                                                        <strong>{{
                                                            newCommonFormatCurrency(
                                                                totalAmountTTC,
                                                                undefined,
                                                            )
                                                        }}</strong>
                                                    </v-col>
                                                </v-row>
                                            </v-expansion-panel-title>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-window-item>
                            </v-window>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <oss-dialog
            :title="'Mois facturé(s)'"
            v-model="clientDetailDialog"
            @close="clientDetailDialog = false"
            width="400px"
        >
            <!-- <div v-for="(month,i) in selectedClientData" :key="i" class="pt-2">
                {{formatDate(month.date)}}
            </div> -->

            <oss-data-table
                :headers="dateHeaders"
                :items="selectedClientData"
                :fixed-header="true"
                :virtual-scroll="true"
                class="table elevation-0"
            >
                <template v-slot:item="props">
                    <tr>
                        <td class="text-left">
                            {{ month(props.item.date) }}
                        </td>
                        <td class="text-center">
                            {{ year(props.item.date) }}
                            <!-- {{formatDate(props.item.date)}} -->
                        </td>
                    </tr>
                </template>
            </oss-data-table>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import gql from "graphql-tag";
import { groupBy, sortBy, uniqBy, orderBy } from "lodash";
import { Apollo } from "@/decorators";

import { Doughnut as DoughnutChart } from "vue-chartjs";

import ossDataTable from "../../ossComponents/ossDataTable2.vue";

import ACCOUNTINGFIRMCLIENTPRICES from "../../../graphql/billing/AccountingFirmClientPrices.gql";
import BILLING_INVOICES from "../../../graphql/billing/BillingInvoices.gql";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../../../services/dateServices";
import { newCommonFormatCurrency } from "../../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        DoughnutChart,
        ossDataTable,
    },
})
export class MainBilling extends Vue {
    @Prop({ default: null }) clients: any;

    invoiceId = "";

    panel = "";

    displayType = "chart";

    accountingClient = null;

    headers: any = [
        { title: "Client", value: "customer", sortable: false },
        { title: "Quantité", value: "quantity", align: "center" },
        { title: "Prix unitaire", value: "unitPrice", align: "end" },
        { title: "Prix HT", value: "netAmount", align: "end" },
        { title: "Prix TTC", value: "grossAmount", align: "end" },
        // { title: "", value: "see", align: "center" },
    ];

    priceListHeaders: any = [
        { title: "Prix", value: "customer", sortable: false },
        { title: "Prix unitaire", value: "unitPrice", align: "end" },
    ];

    dateHeaders: any = [
        { title: "Mois", value: "month" },
        { title: "Année", value: "year", align: "center" },
    ];

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get title() {
        // displayType" touchless>
        if (this.displayType === "priceList") {
            return "Grille tarifaire";
        }
        let title = "Dépense du mois";
        if (this.percentage) {
            title += " (" + this.percentage + "%)";
        }
        return title;
    }

    get invoice() {
        if (this.invoiceId) {
            const array = this.invoices.filter((x) => x.id === this.invoiceId);
            return array.length ? array[0] : null;
        }
        return null;
    }

    get clientId() {
        if (!this.clients?.length) {
            return this.$store.state.user?.company?.id || "";
        } else if (this.accountingClient) {
            return this.accountingClient.id;
        }
        return "";
    }

    get client() {
        if (!this.clients?.length) {
            return this.$store.state.user?.company;
        } else if (this.accountingClient) {
            return this.clients.find((c) => c.id === this.accountingClient.id);
        }
        return "";
    }

    formatDate(date) {
        if (!date) return null;
        return moment(date).format("DD MMMM YYYY");
    }

    month(date) {
        if (!date) return null;
        const sm = moment(date).add(-1, "day").startOf("month");
        return sm.format("MMMM");
    }

    year(date) {
        if (!date) return null;
        return moment(date).format("YYYY");
    }

    @Watch("clientId")
    onClientIdChanged() {
        // await this.update()
        this.updateBobbeeBillingStatus = true;
        this.updateLoading = false;
    }

    get totalAmountHT() {
        if (this.invoice) {
            const reducer = (acc, val) => acc + val.unitPrice * val.quantity * this.percentageRatio;
            const amount = this.lines.reduce(reducer, 0);
            return amount;
        }
        return 0.0;
    }

    get totalAmountTTC() {
        return this.totalAmountHT * 1.2;
    }

    get percentage() {
        if (this.invoice) {
            if (this.invoice.id.startsWith("date#")) {
                let percentage = 0;
                if (this.clientPriceList?.discountPercentage) {
                    let lastdiscountDate;
                    if (this.clientPriceList.discountDuration) {
                        lastdiscountDate = moment(this.accountingFirm.createdAt)
                            .startOf("month")
                            .add(this.clientPriceList.discountDuration, "months")
                            .endOf("month");
                    }
                    const invoice = this.invoices.find((x) => x.id === this.invoiceId);
                    if (invoice) {
                        if (
                            !lastdiscountDate ||
                            moment(invoice?.date).isSameOrBefore(lastdiscountDate)
                        ) {
                            percentage = this.clientPriceList.discountPercentage;
                        }
                    }
                }
                return percentage;
            }
            const percentageLine = this.invoice.lines.find((l) => l.product?.percentage);
            if (percentageLine) {
                return -percentageLine.product.percentage;
            }
        }
        return 0;
    }

    get percentageRatio() {
        let ratio = 1.0;
        if (this.percentage) {
            ratio -= this.percentage / 100;
        }
        return ratio;
    }

    get lines() {
        if (this.invoice) {
            let lines = this.invoice.lines.filter((l) => !l.product?.percentage);

            lines = orderBy(lines, ["product.title"], ["desc"]);
            return lines;
        }
        return [];
    }

    get statsBilling() {
        if (this.invoice) {
            const labels = this.lines.map((x) => x.product.title);
            return {
                labels: labels,
                datasets: [
                    {
                        backgroundColor: ["#f39c12", "#1abc9c", "#2ecc71"],
                        borderColor: ["rgba(255,255,255,1)"],
                        data: this.lines.map(
                            (x) => x.unitPrice * x.quantity * this.percentageRatio,
                        ),
                    },
                ],
            };
        }
        return null;
    }

    updateBobbeeBillingStatus: boolean = true;
    updateLoading: boolean = false;

    async beforeMount() {
        if (!this.clients?.length) {
            this.onClientIdChanged();
        } else if (this.clients?.length > 1) {
            this.accountingClient = this.clients[1];
        }
    }

    @Apollo({
        query: ACCOUNTINGFIRMCLIENTPRICES,
        variables() {
            return {
                invoice: this.invoiceId.startsWith("date#") ? null : { id: this.invoiceId },
                startDate: this.invoiceId.startsWith("date#")
                    ? getDBFormattedStartDate(this.invoice.date)
                    : undefined,
                endDate: this.invoiceId.startsWith("date#")
                    ? getDBFormattedEndDate(this.invoice.date)
                    : undefined,
                siret: this.accountingFirm.siret,
            };
        },
        skip() {
            return (
                !this.accountingFirm ||
                !this.invoiceId ||
                !this.invoice ||
                !this.invoices.find((i) => i.id === this.invoiceId) ||
                !this.updateBobbeeBillingStatus
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    if (data.accountingFirmClientPrices) {
                        this.accountingFirmClientPrices = data.accountingFirmClientPrices;
                        if (this.invoiceId.startsWith("date#")) {
                            this.initInvoiceNow();
                        }
                    }
                }
            }
        },
    })
    accountingFirmClientPrices = [];

    initInvoiceNow() {
        const invoice = this.invoices.find((x) => x.id === this.invoiceId);
        if (invoice) {
            const allProducts = this.accountingFirmClientPrices.map((x) => x.product);
            let lines = uniqBy(allProducts, "id");
            lines = lines.map((x) => ({
                product: x,
                quantity: allProducts.filter((y) => y.id === x.id).length,
                unitPrice: x.unitPrice,
            }));

            invoice.lines = lines;
        }
    }

    getClients(id) {
        if (this.accountingFirmClientPrices.length) {
            const array = this.accountingFirmClientPrices.filter((x) => x.product.id === id);
            const companyStat = groupBy(array, "accountingFirmClient.client.id");
            const result = sortBy(Object.values(companyStat), ["accountingFirmClient.client.name"]);
            return result;
        }
        return [];
    }

    clientDetailDialog: boolean = false;
    selectedClientData: any = null;

    showClientDetail(selectedClientData) {
        this.selectedClientData = selectedClientData;
        this.clientDetailDialog = true;
    }

    @Apollo({
        query: gql`
            query ($clientId: ID!) {
                company(where: { id: $clientId }) {
                    id
                    createdAt
                    siret
                    bobbeePriceList {
                        id
                        discountPercentage
                        discountDuration
                        prices {
                            id
                            accountingType
                            taxSystem
                            withVAT
                            minAccountingLineCount
                            maxAccountingLineCount
                            invoiceProduct {
                                id
                                title
                                unitPrice
                            }
                        }
                    }
                }
            }
        `,
        skip() {
            return !this.clientId || this.clientId === "all";
        },
        variables() {
            return {
                clientId: this.clientId,
            };
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (data.company) {
                this.accountingFirm = data.company;
                // let clientPriceList = null
                // if (data.company.bobbeePriceList) {
                //     clientPriceList = data.company.bobbeePriceList
                // }
                // this.clientPriceList = clientPriceList
            } else {
                // this.clientPriceList = null
                this.accountingFirm = null;
            }
        },
    })
    accountingFirm: any = null;

    get clientPriceList() {
        return this.accountingFirm?.bobbeePriceList;
    }

    @Apollo({
        query: BILLING_INVOICES,
        variables() {
            return {
                siret: this.accountingFirm.siret,
            };
        },
        skip() {
            return !this.accountingFirm || !this.updateBobbeeBillingStatus;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.invoices = data.invoices;
                    let date = moment().endOf("month").startOf("day");
                    if (this.invoices.length) {
                        date = moment(this.invoices[0].date)
                            .add(1, "months")
                            .endOf("month")
                            .startOf("day");
                    } else if (this.client?.createAt) {
                        date = moment(this.client.createAt).endOf("month").startOf("day");
                    }
                    const now = moment();
                    while (date) {
                        date.format("MMMM YYYY");
                        const id = "date#" + date.format("YYYY-MM-DD");
                        this.invoices.unshift({
                            id,
                            title: "Chiffrage du mois " + date.format("MMMM YYYY"),
                            date: date.format(),
                            lines: [],
                        });
                        if (date.isBefore(now)) {
                            date = date.add(1, "months").endOf("month").startOf("day");
                        } else {
                            this.invoiceId = id;
                            date = null;
                        }
                    }
                    if (this.invoiceId.startsWith("date#")) {
                        this.initInvoiceNow();
                    }
                } else {
                    this.invoices = [];
                    this.invoiceId = "";
                }
            }
        },
    })
    invoices = [];

    resetDisplay() {
        this.panel = "";
    }

    getProductTitle(product) {
        let title = "";
        // if (product.reference) {
        //     title = product.reference + " - "
        // }
        title += product.title;
        return title;
    }

    async download() {
        if (this.invoice?.signedUrl) {
            window.open(this.invoice.signedUrl, "_blank");
        }
    }

    // @Watch('displayType')
    // test() {
    //     debugger
    //     this.displayType
    // }
}

export default toNative(MainBilling);
</script>

<style lang="scss" scoped>
.inside_card {
    background: white !important;
    padding: 2px;
    border-radius: 16px;
    border: solid 1px rgba($color: #000000, $alpha: 0.12);
}
</style>
